/** Filter console on `[DocViewerLoad]`. Load / mount / loader only — not per-page overlay work. */
const PREFIX = "[DocViewerLoad]";

export function viewerLoadLog(step: string, detail?: Record<string, unknown>): void {
  if (detail) {
    console.log(PREFIX, step, detail);
  } else {
    console.log(PREFIX, step);
  }
}

/** Compact src label so blob/data URLs are not dumped. */
export function viewerLoadSrcKind(src: unknown): string {
  if (src == null || src === "") {
    return "empty";
  }
  if (typeof src !== "string") {
    return "binary";
  }
  if (src.startsWith("blob:")) {
    return "blob";
  }
  if (src.startsWith("data:")) {
    return `data:${src.length}`;
  }
  return `str:${src.length}`;
}
